import { render } from "./F2List.vue?vue&type=template&id=0dd4e645&scoped=true&ts=true"
import script from "./F2List.vue?vue&type=script&lang=ts"
export * from "./F2List.vue?vue&type=script&lang=ts"

import "./F2List.vue?vue&type=style&index=0&id=0dd4e645&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dd4e645"]])

export default __exports__